import { DashboardLKModel as Model } from './Model'


export const MODULE_NAME = 'dashboard-lk'

export const DASHBOARD_LK_ROUTES = {
  LAYOUT: MODULE_NAME,
  INDEX: `${MODULE_NAME}.index`,
} as const

export const MENU = {
  id: DASHBOARD_LK_ROUTES.LAYOUT,
  route: { name: DASHBOARD_LK_ROUTES.LAYOUT },
  label: Model.page_title.index,
  icon: 'mdi-view-dashboard',
} as const
